(function (root) {
  "use strict";
  function evaluate(cart, config, now) {
    var active = !!config.enabled && Number(now) < Number(config.endsAtMs);
    var required = String(config.requiredDiscountCode || "new1026").toLowerCase();
    var ids = new Set((config.qualifyingProductIds || []).map(String));
    var items = (cart && cart.items) || [];
    var codes = (cart && cart.discount_codes) || [];
    var codePresent = codes.some(function (code) { return String(code.code || "").toLowerCase() === required; });
    var codeApplicable = codes.some(function (code) { return String(code.code || "").toLowerCase() === required && code.applicable === true; });
    // The presence of a link or cookie alone does not grant a gift.
    // Confirm Shopify really allocated the specified 10% code to a qualifying item.
    var discountedNew = items.some(function (item) {
      return Number(item.quantity) > 0 && ids.has(String(item.product_id)) &&
        (item.line_level_discount_allocations || []).some(function (allocation) {
          var app = allocation.discount_application || {};
          return Number(allocation.amount) > 0 && app.type === "discount_code" &&
            String(app.title || "").toLowerCase() === required &&
            app.value_type === "percentage" && Number(app.value) === Number(config.requiredDiscountPercent || 10);
        });
    });
    // Approved renewal through31Oct: one gift on ANY purchase containing a
    // New Collection item. The existing10% member code is independent.
    // Default remains strict code validation for other/future configurations.
    var qualifyingNew = items.some(function (item) { return Number(item.quantity) > 0 && ids.has(String(item.product_id)); });
    var codeRequired = config.requireDiscountCode !== false;
    var qualifies = active && (codeRequired ? codeApplicable && discountedNew : qualifyingNew);
    return {
      active: active,
      codePresent: codePresent,
      codeApplicable: codeApplicable,
      eligible: qualifies,
      showInvitation: active && codePresent && !qualifies && !items.some(function (item) { return Number(item.quantity) > 0 && ids.has(String(item.product_id)); }) && items.some(function (item) { return Number(item.quantity) > 0; }),
      attributeValue: qualifies ? config.attributeValue : ""
    };
  }
  if (typeof module === "object" && module.exports) { module.exports = {evaluate: evaluate}; return; }
  if (!root.document || root.__ingoLavenderGift || typeof root.AbortController !== "function") return;
  var node = root.document.getElementById("ingo-lavender-gift-config");
  if (!node) return;
  var config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (!config.enabled || !Array.isArray(config.qualifyingProductIds) || !config.qualifyingProductIds.length) return;
  var base = ((root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || "/").replace(/\/?$/, "/");
  var originalFetch = root.fetch.bind(root), flight = null, rerun = false, verifiedState = null;
  // Sync ONLY the requested offer when the existing coupon widget adds/removes
  // its confirmed code chip. Do not modify the widget, its settings or other codes.
  // Coupon syncing remains exact-code-only; gift eligibility follows the approved config.
  var requiredManualCode = String(config.requiredDiscountCode || "new1026").toLowerCase();
  var manualDesired = null, manualGeneration = 0, manualProcessed = 0;
  var manualFlight = null, manualTimer = null;
  var manualRemovalIntent = false, manualRefreshRequired = false;
  function hasManualCodeTag() {
    return Array.prototype.some.call(root.document.querySelectorAll(
      ".limoniapps-discountninja-cartdiscountfield-discountcode[data-discountcode]"
    ), function (el) {
      return String(el.getAttribute("data-discountcode") || "").toLowerCase() === requiredManualCode;
    });
  }
  function nativeCodes(cart) {
    return ((cart && cart.discount_codes) || []).map(function (entry) { return String(entry.code || ""); }).filter(Boolean);
  }
  function containsRequiredCode(codes) {
    return codes.some(function (code) { return code.toLowerCase() === requiredManualCode; });
  }
  function observeManualCode() {
    if (Number(config.endsAtMs) <= Date.now()) return;
    var present = !manualRemovalIntent && hasManualCodeTag();
    // A normal visit or a newsletter-link code without a widget chip is untouched.
    if ((!present && manualDesired === null) || present === manualDesired) return;
    manualDesired = present; manualGeneration += 1;
    verifiedState = null; render();
    root.clearTimeout(manualTimer);
    manualTimer = root.setTimeout(function () { manualTimer = null; syncManualCode(); }, 250);
  }
  function syncManualCode() {
    if (manualFlight) return manualFlight;
    manualFlight = (async function () {
      while (manualProcessed !== manualGeneration) {
        var generation = manualGeneration, desired = manualDesired;
        var cart = await readCart();
        if (generation !== manualGeneration) continue;
        var codes = nativeCodes(cart);
        if (containsRequiredCode(codes) !== desired) {
          // Preserve every other native code. Do not change products, quantities,
          // prices, app promotion settings or code configuration.
          codes = codes.filter(function (code) { return code.toLowerCase() !== requiredManualCode; });
          if (desired) codes.push(config.requiredDiscountCode || "new1026");
          await cartJSON(base + "cart/update.js", {method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({discount:codes.join(",")})});
          if (generation !== manualGeneration) continue;
          cart = await readCart();
          if (containsRequiredCode(nativeCodes(cart)) !== desired) throw new Error("Manual offer code readback mismatch");
        }
        if (generation !== manualGeneration) continue;
        manualProcessed = generation;
        await reconcile();
        // The widget may briefly rebuild a removed chip from its pre-removal
        // native-cart cache. Refresh ONLY after this offer's explicit removal
        // and verified gift-note cleanup; never let that stale chip reapply it.
        if (manualRefreshRequired && generation === manualGeneration && manualDesired === false) {
          manualRefreshRequired = false;
          root.location.reload();
          return;
        }
      }
    })().catch(function () {
      verifiedState = null; render();
      root.console.warn("[Ingo lavender gift] Manual offer code could not be verified; no gift confirmation shown.");
    }).finally(function () { manualFlight = null; });
    return manualFlight;
  }
  async function reconcileManualAndGift() {
    observeManualCode();
    root.clearTimeout(manualTimer); manualTimer = null;
    if (manualProcessed !== manualGeneration) await syncManualCode();
    return reconcile();
  }
  var marker = "data-ingo-lavender-gift";
  function releaseRemovalForApply(input) {
    if (input && String(input.value || "").toLowerCase() === requiredManualCode) {
      manualRemovalIntent = false; manualRefreshRequired = false; observeManualCode();
    }
  }
  root.document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== "function") return;
    var close = target.closest(".limoniapps-discountninja-cartdiscountfield-discountcode-close");
    var tag = close && close.closest(".limoniapps-discountninja-cartdiscountfield-discountcode[data-discountcode]");
    if (tag && String(tag.getAttribute("data-discountcode") || "").toLowerCase() === requiredManualCode) {
      manualRemovalIntent = true; manualRefreshRequired = true; observeManualCode();
      root.clearTimeout(manualTimer); manualTimer = null; syncManualCode();
      return;
    }
    var apply = target.closest(".limoniapps-discountninja-cartdiscountfield-apply");
    var wrapper = apply && apply.closest(".limoniapps-discountninja-cartdiscountfield-wrapper");
    if (wrapper) releaseRemovalForApply(wrapper.querySelector(".limoniapps-discountninja-cartdiscountfield-input"));
  }, true);
  root.document.addEventListener("keydown", function (event) {
    if (event.key === "Enter" && event.target && event.target.matches(".limoniapps-discountninja-cartdiscountfield-input")) releaseRemovalForApply(event.target);
  }, true);
  function render() {
    var state = verifiedState;
    var targets = new Set();
    root.document.querySelectorAll(".ajaxcart__footer-wrapper").forEach(function (el) { targets.add(el); });
    root.document.querySelectorAll(".cart--button-checkout").forEach(function (el) { if (el.parentNode) targets.add(el.parentNode); });
    targets.forEach(function (target) {
      var box = target.querySelector(":scope > [" + marker + "]");
      var kind = state && state.eligible ? "gift" : state && state.showInvitation ? "invite" : "none";
      if (kind === "none") { if (box) box.remove(); return; }
      if (box && box.dataset.kind === kind) return;
      if (!box) {
        box = root.document.createElement("aside"); box.setAttribute(marker, "");
        box.setAttribute("dir", "rtl"); box.setAttribute("role", "status");
        box.style.cssText = "padding:14px;margin:10px 0 16px;background:#eee8f2;border:1px solid #d6c8df;color:#292722;font-size:16px;line-height:1.6;text-align:right;width:100%;box-sizing:border-box;";
        target.insertBefore(box, target.firstChild);
      }
      box.dataset.kind = kind; box.textContent = "";
      if (kind === "gift") { box.textContent = "קיבלת את בושם הטקסטיל של יעל במתנה 💜"; }
      else {
        box.appendChild(root.document.createTextNode("לקבלת בושם הטקסטיל במתנה הוסיפי פריט מהקולקציה החדשה. "));
        var link = root.document.createElement("a"); link.href = config.collectionUrl || "/collections/new-collection";
        link.textContent = "גלי את הקולקציה החדשה"; link.style.cssText = "color:#655572;text-decoration:underline;"; box.appendChild(link);
      }
    });
  }
  async function cartJSON(url, options) {
    // Only our own requests are bounded; existing shop fetch/XHR behavior is unchanged.
    var controller = new root.AbortController();
    var timer = root.setTimeout(function () { controller.abort(); }, 5000);
    try {
      var response = await originalFetch(url, Object.assign({}, options, {signal:controller.signal}));
      if (!response.ok) throw new Error("Gift cart request failed: " + response.status);
      return await response.json();
    } finally { root.clearTimeout(timer); }
  }
  async function readCart() {
    return cartJSON(base + "cart.js", {credentials:"same-origin",cache:"no-store",headers:{"Accept":"application/json"}});
  }
  async function sync() {
    try {
      var cart = await readCart(), state = evaluate(cart, config, Date.now());
      var current = (cart.attributes || {})[config.attributeKey] || "";
      if (current !== state.attributeValue) {
        var attributes = {}; attributes[config.attributeKey] = state.attributeValue;
        await cartJSON(base + "cart/update.js", {method:"POST",credentials:"same-origin",headers:{"Content-Type":"application/json","Accept":"application/json"},body:JSON.stringify({attributes:attributes})});
        cart = await readCart();
        if (((cart.attributes || {})[config.attributeKey] || "") !== state.attributeValue) throw new Error("Gift note readback mismatch");
        // A concurrent item change is reconciled before any new confirmation is shown.
        if (evaluate(cart, config, Date.now()).attributeValue !== state.attributeValue) { rerun = true; return; }
      }
      verifiedState = manualProcessed !== manualGeneration ? null : evaluate(cart, config, Date.now()); render();
    } catch (error) {
      verifiedState = null; render();
      root.console.warn("[Ingo lavender gift] No gift confirmation shown because cart verification failed.");
    }
  }
  function reconcile() {
    rerun = true;
    if (flight) return flight;
    flight = (async function () { do { rerun = false; await sync(); } while (rerun); })().finally(function () { flight = null; });
    return flight;
  }
  function isCartMutation(url, method) {
    try {
      var u = new URL(String(url), root.location.href);
      return u.origin === root.location.origin && String(method || "GET").toUpperCase() === "POST" && /\/cart\/(add|change|update|clear)(\.js)?$/.test(u.pathname);
    } catch (_) { return false; }
  }
  root.fetch = function (input, options) {
    var url = typeof input === "string" ? input : input && input.url;
    var method = options && options.method || input && input.method || "GET";
    var result = originalFetch(input, options);
    if (isCartMutation(url, method)) result.then(function (response) { if (response.ok) reconcile(); }, function () {});
    return result;
  };
  var xhrOpen = root.XMLHttpRequest.prototype.open;
  root.XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url, method)) this.addEventListener("loadend", function () { if (this.status >= 200 && this.status < 300) reconcile(); }, {once:true});
    return xhrOpen.apply(this, arguments);
  };
  var observer = new MutationObserver(function () { render(); observeManualCode(); });
  observer.observe(root.document.documentElement, {childList:true,subtree:true,attributes:true,attributeFilter:["data-discountcode"]});
  root.addEventListener("pageshow", reconcileManualAndGift);
  root.document.addEventListener("visibilitychange", function () { if (!root.document.hidden) reconcileManualAndGift(); });
  root.document.addEventListener("submit", function (event) {
    var form = event.target, submitter = event.submitter;
    if (!form || form.dataset.ingoGiftSubmitting === "1" || !(submitter && submitter.name === "checkout")) return;
    event.preventDefault();
    // A network problem in the optional gift note must never hold up a purchase.
    var checkoutTimer;
    Promise.race([reconcileManualAndGift(), new Promise(function (resolve) { checkoutTimer = root.setTimeout(resolve, 2500); })]).finally(function () {
      root.clearTimeout(checkoutTimer);
      form.dataset.ingoGiftSubmitting = "1";
      try { form.requestSubmit(submitter); } finally { delete form.dataset.ingoGiftSubmitting; }
    });
  }, true);
  if (Number(config.endsAtMs) > Date.now()) root.setTimeout(reconcile, Math.min(Number(config.endsAtMs) - Date.now() + 100, 2147483647));
  root.__ingoLavenderGift = {reconcile:reconcile, evaluate:evaluate, getState:function () { return verifiedState; }};
  if (root.document.readyState === "loading") root.document.addEventListener("DOMContentLoaded", reconcile, {once:true});
  else reconcile();
})(typeof window !== "undefined" ? window : globalThis);
